<template>
  <oxd-input-field
    type="select"
    :label="$t('performance.kpi_categories')"
    :options="options"
  />
</template>

<script>
import {ref, onBeforeMount} from 'vue';
import {APIService} from '@ohrm/core/util/services/api.service';
export default {
  name: 'KpiCategoriesDropdown',
  setup() {
    const options = ref([]);
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/performance/kpi-categories',
    );
    onBeforeMount(() => {
      http.getAll({limit: 0}).then(({data}) => {
        options.value = data.data.map((item) => {
          return {
            id: item.id,
            label: item.name,
            weight: item.weight,
          };
        });
      });
    });
    return {
      options,
    };
  },
};
</script>
